import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function CustomDialog({
  open,
  onClose,
  title,
  header, // custom header JSX
  content,
  body, // optional alias for content
  actions,
  footer, // custom footer JSX
  showCloseIcon = false,
  maxWidth = 'sm',
  fullWidth = true
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      // fullWidth={fullWidth}
      aria-labelledby="custom-dialog-title"
      aria-describedby="custom-dialog-description"
    >
      {/* Header */}
      {header ? (
        <DialogTitle
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          {header}
          {showCloseIcon && (
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      ) : (
        title && (
          <DialogTitle
            id="custom-dialog-title"
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
          >
            <Typography variant="h6">{title}</Typography> &nbsp;
            {showCloseIcon && (
              <IconButton onClick={onClose} size="small">
                <CloseIcon />
              </IconButton>
            )}
          </DialogTitle>
        )
      )}

      {/* Body / Content */}
      <DialogContent>
        {body ? (
          body
        ) : typeof content === 'string' ? (
          <DialogContentText id="custom-dialog-description">{content}</DialogContentText>
        ) : (
          content
        )}
      </DialogContent>

      {/* Footer / Actions */}
      {footer ? (
        <DialogActions>{footer}</DialogActions>
      ) : (
        actions && <DialogActions>{actions}</DialogActions>
      )}
    </Dialog>
  );
}

export default CustomDialog;
